import * as React from 'react';
import { Link } from '@fluentui/react';

import { Configuration as ConfigurationStep, ConfigurationProps } from '../../steps/Configuration';
import { stepStyles as styles } from '../../steps/commonStyles';
import { Title } from 'components/common/Title';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';

export const Configuration = (props: ConfigurationProps) => {
	const { t } = React.useContext(TranslationsContext)!;
	return (
		<ConfigurationStep {...props}>
			<Title id='form-title'>{t(translationKeys.Deployment.Configuration.Step.Title)}</Title>
			<p className={styles.formElement}>{t(translationKeys.Deployment.Configuration.Step.Paragraph)} <Link underline={true} target="_blank" href="https://aka.ms/mc4n/installer/docs/">{t(translationKeys.Deployment.Configuration.Step.LinkText)}</Link></p>
		</ConfigurationStep>);
};
